import React, {useEffect} from 'react'
import PropTypes from 'prop-types';
import {KeyboardDateTimePicker} from '@material-ui/pickers';
import Tr from 'translations/Translations';
import getObjectValue from 'libs/getObjectValue'
import DateFormats from "constants/DateFormats";
import moment from "libs/moment";

function DateTimePicker(
    {
        formikProps,
        id,
        label,
        minDate,
        maxDate,
        required = false,
        onChange = () => {
        },
        disabled = false,
        className,
        skipCheckTouched
    }) {

    const editable = disabled ? false : getObjectValue('_editable', formikProps.values, true);
    const errorValue = getObjectValue(id, formikProps.errors, null);
    const value = getObjectValue(id, formikProps.values, null);
    const touched = getObjectValue(id, formikProps.touched, !!skipCheckTouched);

    useEffect(()=> {
        if( typeof value === 'string' || value instanceof String) {
            const momentVal = moment(value);
            if(momentVal.isValid()) {
                formikProps.setFieldValue(id, momentVal);
                formikProps.validateField(id);
            }
        }
        // eslint-disable-next-line
    },[])

    const handleChange = (date) => {
        const value = date ? date : null;
        formikProps.setFieldValue(id, value);
        formikProps.setFieldTouched(id, true);
        setTimeout((id) => {try {formikProps.validateField(id)} catch (e){}}, 1, id);
        onChange(value ? value.clone() : null)
    };

    const handleError = (err) => {
        if (!Boolean(errorValue)) {
            if (errorValue !== err && err.length > 0) {
                formikProps.setFieldError(id, err)
            }
        }
    };
    const isError = editable && !!errorValue && Boolean(touched);
    const helperText = errorValue || ' ';

    return (
        <KeyboardDateTimePicker
            className={className}
            disabled={!editable}
            ampm={false}
            label={required ? label + '*' : label}
            name={id}
            value={value}
            format={DateFormats.DATETIME_FORMAT}
            onChange={handleChange}
            onBlur={formikProps.handleBlur}
            error={isError}
            helperText={isError ? helperText : ' '}
            minDate={minDate}
            maxDate={maxDate}
            onError={handleError}
            invalidDateMessage={Tr('invalid_date_format')}
            minDateMessage={Tr("v_data_can_not_be_past")}
            maxDateMessage={Tr("v_data_can_not_be_future")}
            variant='dialog'
            cancelLabel={Tr('cancel')}
            inputProps={{
                "data-id": id
            }}
            //onOpen={formikProps.handleBlur}
        />
    )
}

DateTimePicker.propTypes = {
    classes: PropTypes.any,
    required: PropTypes.bool
}

export default DateTimePicker;